<template>
<area-component
  :ad="Array.isArray(ad)?{}:ad"
  :show-skeleton="showSkeleton"
  v-model="isLoading"
  ref="areaComponent"
  @onRefresh="onRefresh"
  @loadData="loadData"
  :error-img="require(`@/assets/img/home/promotion_banner.jpg`)"
  title="促销套装">
   <goods-item
     v-for="(item,index) in list"
     :item="item"
     :key="index"
   />
   <not-goods v-if="list.length === 0"></not-goods>
</area-component>
</template>

<script>
import AreaComponent from '../components/area-component'
import GoodsItem from './item'
import { requestPromotionlist } from '../../../fetch/home/promotionlist'
import ListMixin from '@/mixins/list'
import NotGoods from '../components/not-goods'
import CountDownMixin from '@/mixins/countDown'
let timer = null
export default {
  name: 'promotionlist',
  mixins: [ListMixin, CountDownMixin],
  components: { NotGoods, GoodsItem, AreaComponent },
  data () {
    return {
      list: [],
      ad: null,
      isLoading: false,
      showSkeleton: true
    }
  },
  created () {
    this.$nextTick(() => {
      this.loadData()
    })
  },
  computed: {
    areaComponent () {
      return this.$refs.areaComponent
    }
  },
  methods: {
    judgeTime (item) {
      return parseInt(+item.end_date - +item.now_time)
    },
    onRefresh () {
      this.areaComponent.mReset()
      this.loadData(true)
    },
    async loadData (reset) {
      const params = {
        page: this.areaComponent.m_page.curr,
        limit: this.areaComponent.m_page.limit
      }
      const res = await requestPromotionlist(params)
      this.$tips(res, {
        tip: false
      }, res => {
        if (this.showSkeleton) {
          this.showSkeleton = false
        }
        this.isLoading = false
        const data = res
        this.ad = data.ad
        if (data.promotion_list_data.length === 0) {
          this.areaComponent.mEnd('--我也是有底线的--')
          if (reset) {
            this.list = []
          }
          if (this.list.length === 0) {
            this.areaComponent.m_finishedText = ''
          }
        } else {
          if (reset) {
            this.list = data.promotion_list_data
          } else {
            this.list.push(...data.promotion_list_data)
          }
          // this.addGoodField(this.list)
          this.list.forEach(item => {
            this.$set(item, 'countDown', {
              d: '',
              h: '',
              m: '',
              s: ''
            })
            this.countDown(item)
          })
        }
        this.areaComponent.mSuccess()
      })
    }
  },
  beforeDestroy () {
    clearTimeout(timer)
  }
}
</script>

<style scoped lang="scss">

</style>
